import { render, staticRenderFns } from "./WsReadinessCPDEForm.vue?vue&type=template&id=27f05524&scoped=true"
import script from "./WsReadinessCPDEForm.vue?vue&type=script&lang=js"
export * from "./WsReadinessCPDEForm.vue?vue&type=script&lang=js"
import style0 from "./WsReadinessCPDEForm.vue?vue&type=style&index=0&id=27f05524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f05524",
  null
  
)

export default component.exports